import Vue from '@/config'

export default class EducationFactory {
  create() {
    const educations = []
    const keys = Object.keys(Vue.config.localization.ru.educations)
    for (let i = 0; i < keys.length; i++) {
      educations.push({
        id: parseInt(keys[i]),
        title: Vue.config.localization.ru.educations[keys[i]],
      })
    }
    return educations
  }
}
